import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { Layout } from "./layout/layout";
import Calendar from "./pages/calendar/calendar";
import DateEvents from "./pages/date-events/date-events";
import Description from "./pages/description/description";
import { CalendarDataProvider } from "./shared/data-access/calendar-data.provider";
import { ThemeProvider } from "./themes/theme-provider";
import { useEffect, useState } from "react";
import YearEvents from "./pages/year-events/year-events";
import AboutProject from "./pages/about-project/about-project";

export const baseImgUrl = process.env.PUBLIC_URL || "/";

const App = () => {
  const [fontSize, setFontSize] = useState(16);

  const calculateFontSize = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    const baseWidth = 1920;
    const baseHeight = 1080;
    const baseFontSize = 20;

    const scaleFactor = Math.sqrt((width * height) / (baseWidth * baseHeight));

    const newFontSize = baseFontSize * scaleFactor;

    setFontSize(newFontSize);
  };

  useEffect(() => {
    calculateFontSize();
    window.addEventListener("resize", calculateFontSize);

    return () => window.removeEventListener("resize", calculateFontSize);
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--dynamic-font-size",
      `${fontSize}px`
    );
  }, [fontSize]);
  return (
    <Router basename={baseImgUrl}>
      {/* <Router> */}
      <ThemeProvider>
        <CalendarDataProvider>
          <Layout>
            <Routes>
              <Route path="/:date?" element={<Calendar />} />
              <Route path="/date-events/:date?/" element={<DateEvents />} />
              <Route path="/description/:id/:date?" element={<Description />} />
              <Route path="/year-events/:date?/" element={<YearEvents />} />
              <Route path="/about-project/:date?/" element={<AboutProject />} />
              <Route path="*" element={<h2>Страница не найдена</h2>} />
            </Routes>
          </Layout>
        </CalendarDataProvider>
      </ThemeProvider>
    </Router>
  );
};

export default App;
